import classnames from 'classnames/bind'
import React from 'react'

import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoCenteredImageTextProps {
  className?: string
  title?: RichTextBlock[]
  image?: ImageProps
}

function EditoCenteredImageText({
  className,
  title,
  image,
}: EditoCenteredImageTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({
    textPreset: 'title-content-section',
  })

  return (
    <div className={cx(css.EditoCenteredImageText, className)}>
      <div className={cx(css.content, gridStyle)}>
        {title && (
          <RichText className={cx(css.title, titleStyle)} render={title} />
        )}
        {image && (
          <ImageWithPlaceHolder
            className={cx(css.image, css.hideOnSmallScreen)}
            layout="responsive"
            {...image}
          />
        )}
        {image && (
          <ImageWithPlaceHolder
            layout="fill"
            objectFit="cover"
            className={cx(css.image, css.hideOnLargeScreen)}
            {...image}
          />
        )}
      </div>
    </div>
  )
}

EditoCenteredImageText.defaultProps = {}

export default EditoCenteredImageText
